import React, { FC, ReactNode } from 'react';
import { Grid } from '@material-ui/core';
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles';

import { columnSplitToGridSizes } from 'helpers';

const styles = (theme: Theme) =>
  createStyles({
    container: {
      [theme.breakpoints.up('lg')]: {
        margin: theme.custom.bodyMargin,
      },
    },
    main: {
      marginTop: theme.custom.mainOffset,
      [theme.breakpoints.between('xs', 'md')]: {
        marginTop: theme.spacing(12),
      },
    },
  });

interface IProps extends WithStyles<typeof styles> {
  sidebar: ReactNode;
  main: ReactNode;
  desktopSplit?: string;
}

const App2Column: FC<IProps> = props => {
  const { classes, desktopSplit, sidebar, main } = props;
  const [desktopLeft, desktopMain] = columnSplitToGridSizes(desktopSplit);

  return (
    <div className={classes.container}>
      <Grid container>
        <Grid item xs={12} lg={desktopLeft}>
          {sidebar}
        </Grid>
        <Grid item xs={12} lg={desktopMain} className={classes.main}>
          {main}
        </Grid>
      </Grid>
    </div>
  );
};

App2Column.defaultProps = {
  desktopSplit: '3/9',
};

export default withStyles(styles)(App2Column);
